import {
  AuthorizationFailedReason,
  IncidentType
} from "@moderrotech/servers-communication-library/src/types";

export const pt = {
  topics: {
    headerTitle: "Tópicos",
    search: "Procurar",
    noTopics: "Nenhum tópico encontrado",
    notFound: "Nenhum tópico correspondente ao padrão encontrado",
    schedule: {
      closed: "Estamos fechados"
    },
    customerInfoForm: {
      title: "Antes de começarmos sua videochamada...",
      description:
        "Antes de usar o videobanking para solicitar seu empréstimo, preencha o formulário",
      optional: "Opcional",
      buttons: {
        cancel: "Cancelar",
        submit: "Iniciar videochamada"
      }
    }
  },
  call: {
    calling: "Chamando...",
    joining: "Entrando na chamada",
    transferring: "Transferindo a chamada",
    aspectRatio: "Ampliação",
    cancel: "Cancelar chamada",
    end: "Encerrar chamada",
    share: "Chamada compartilhada",
    document: "Documento",
    actions: "Ações",
    closeActions: "Cancelar",
    mute: "Mudo",
    unmute: "Ativar som",
    textMessage: "Mensagem de texto",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return isPositionAvailable
        ? `Você é o número ${position} na fila`
        : "Você está na fila";
    },
    ticket: "ticket",
    camera: {
      enable: "Ativar câmera",
      disable: "Desativar câmera"
    },
    hangupRequest: {
      title: "Tem certeza?",
      body: "Você realmente quer se desconectar?",
      yes: "Sim, desligar",
      no: "Não, fique na chamada"
    },
    downloadFileRequest: {
      title: "O agente compartilhou um arquivo com você",
      yes: "Aceitar",
      no: "Não aceitar"
    },
    openUrlRequest: {
      title: "Abrir URL",
      body: "A atendente deseja abrir um URL em uma nova guia",
      yes: "Abrir URL",
      no: "Cancelar"
    },
    lowPerformanceNotification: {
      title:
        "Estamos enfrentando alguns problemas técnicos. Por favor, tente novamente",
      gotIt: "Entendi"
    },
    signaturePad: {
      submit: "Enviar",
      clear: "Claro",
      cancel: "Cancelar"
    },
    paintover: {
      submit: "Enviar",
      clear: "Claro",
      cancel: "Cancelar"
    },
    textMessageForm: {
      placeholder: "Mensagem"
    },
    recordTranslator: {
      transcribing: "Fale por favor"
    },
    cameraSnapshot: {
      title: "Captura de tela"
    },
    mediaInputsAccessNote: {
      title: "Permita o acesso ao microfone e à câmera",
      description:
        "Procure um pequeno pop-up próximo à barra de endereço do seu navegador."
    },
    animatedCharacter: {
      listening: {
        title: "O agente está ouvindo",
        description: "Você já pode falar. Diga sua pergunta ou solicitação."
      },
      thinking: {
        title: "O agente está pensando",
        description: "Por favor, aguarde enquanto o agente busca uma resposta."
      }
    },
    success: {
      document: "O documento foi enviado com sucesso.",
      feedback: "Um feedback foi enviado",
      textMessage: "A mensagem de texto foi enviada",
      signaturePad: "A assinatura foi enviada",
      paintover: "A imagem foi enviada",
      textCopy: "O texto foi copiado para a área de transferência",
      imageCopy: "A imagem foi copiada para a área de transferência",
      callSharing: "O link foi copiado para a área de transferência"
    },
    error: {
      base: "Algo deu errado. Por favor recarregue a página",
      mediaInputsAccess:
        "Não é possível obter acesso ao microfone e/ou câmera. Por favor, procure um atendente na agência e avise-o",
      join: "Não é possível participar da chamada",
      document: "Não é possível enviar documento",
      noExperts: "Nenhum especialista disponível",
      noTopic: "O tópico não está mais disponível",
      queueSuspended:
        "Fila suspensa<br>Não podemos atender novas chamadas no momento. Por favor, tente novamente mais tarde.",
      queueOverloaded:
        "Fila sobrecarregada<br>Estamos enfrentando um grande volume de chamadas. Por favor, tente novamente mais tarde.",
      timeout: "Esperando muito tempo por um atendente",
      documentSize: "O documento é muito grande",
      feedback: "Algo deu errado",
      noRoom: "A consulta expirou ou foi cancelada pelo atendente",
      textMessage: "A mensagem de texto não pode ser enviada",
      signaturePad: "A assinatura não pode ser enviada",
      paintover: "O erro de envio de imagem",
      textCopy: "Não é possível copiar texto",
      imageCopy: "Não é possível copiar a imagem",
      callSharing: "Não é possível compartilhar o link",
      recordTranslation: {
        play: "Não é possível reproduzir o áudio da tradução",
        streamGetting: "Não é possível obter fluxo de áudio",
        transcription: "Não é possível transcrever o registro",
        translation: "Não é possível traduzir o registro",
        unsupportedLanguage:
          "Selecionado como não suportado para seu idioma de tradução de áudio. Mas o áudio do atendente pode ser traduzido neste idioma"
      },
      geolocation: "Não é possível obter geolocalização",
      cameraSnapshot: "Não é possível capturar tela"
    },
    onHold: {
      title: "Em espera.",
      description: "Um atendente falará com você em breve."
    },
    remoteActionRequest: {
      shareFile: {
        title:
          "A atendente deseja compartilhar um arquivo do seu dispositivo. Permitir?",
        yes: "Sim",
        no: "Não"
      },
      screenSharing: {
        title:
          "A atendente gostaria de visualizar a tela do totem para te apoiar melhor, você permite?",
        yes: "Sim",
        no: "Não"
      }
    },
    settings: {
      title: "Configurações",
      labels: {
        camera: "Câmera",
        microphone: "Microfone"
      }
    }
  },
  thank: {
    toTopics: "Voltar aos tópicos",
    redirect: "Para consulta"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "Tempo esgotado."
          : "Nenhum atendente disponível para atender sua chamada.";
      },
      body:
        "Você pode deixar uma mensagem para uma atendente para que eles possam entrar em contato com você assim que estiverem disponíveis",
      yes: "Deixar mensagem",
      no: "Não, obrigado"
    },
    form: {
      labels: {
        phone: "Telefone",
        email: "E-mail",
        message: "Mensagem"
      },
      buttons: {
        cancel: "Cancelar",
        submit: "Envie uma mensagem"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "De:",
          validation: {
            label: "e-mail"
          }
        },
        message: {
          label: "mensagem",
          placeholder: "Mensagem",
          validation: {
            label: "mensagem"
          }
        }
      },
      buttons: {
        submit: "Enviar",
        cancel: "Cancelar",
        open: "Adicionar mensagem de feedback..."
      },
      notifications: {
        success: "O relatório de bug foi enviado"
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "Um atendente está se conectando à chamada e falará com você em instantes"
          : "Serviço temporariamente indisponível";
      },

      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "Estamos restabelecendo a conexão, aguarde um instante"
          : "A conexão foi perdida. Reconectando...";
      },
      code: "código: 503"
    },
    login: {
      credentials: "Nome de usuário ou senha errados",
      default: "Algo deu errado"
    },
    unpublished: {
      title: "O aplicativo não existe.",
      description:
        "Pode ter sido temporariamente despublicado ou excluído permanentemente.",
      code: "código: 404"
    },
    authorization: {
      title: "Acesso proibido",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "O aplicativo não está disponível em seu país ou região.",
          [AuthorizationFailedReason.noLicense]: "Nenhuma licença atribuída.",
          [AuthorizationFailedReason.remStopped]: "Serviço não disponível.",
          [AuthorizationFailedReason.noPtpcResponse]:
            "Nenhuma resposta do servidor."
        }[reason];
      },
      code: "código: 403"
    },
    network: {
      title: "Por favor, certifique-se de ter acesso à Internet"
    }
  },
  validation: {
    phone: "O campo {field} deve ser um número de telefone válido",
    dni: "ID errado, formato inválido",
    nie: "ID errado, formato inválido"
  }
};
